(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-stories-04"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if(root.dataset.ready) return;
    root.dataset.ready='1';
    if(root.dataset.previewTheme){root.querySelectorAll('a[href]').forEach(a=>{const url=new URL(a.href,location.origin);if(url.origin===location.origin&&!a.getAttribute('href').startsWith('#')){url.searchParams.set('preview_theme_id',root.dataset.previewTheme);a.href=url.href;}});}
    const dialog=root.querySelector('dialog');
    if(!dialog) return;
    const photos=[...root.querySelectorAll('[data-story]')];
    if(!photos.length)return;
    const duration=Number(root.dataset.storyDuration)||8000,autoplay=root.dataset.autoplay!=='false';
    const full=dialog.querySelector('.a04-full'),progress=dialog.querySelector('.a04-progress'),counter=dialog.querySelector('.a04-counter'),pause=dialog.querySelector('[data-pause]'),labels=dialog.querySelector('.a04-labels');
    let index=0,paused=false,elapsed=0,last=0,frame=0,opener=null,previousOverflow='',pointer=null,suppressClick=false,busy=false,selectedProduct=null,loadId=0,pausedBeforeSheet=false;
    const sheet=dialog.querySelector('.a04-sheet'),buy=dialog.querySelector('[data-buy]'),variant=dialog.querySelector('[data-variant]'),add=dialog.querySelector('[data-add]'),message=dialog.querySelector('[data-message]'),commerce=JSON.parse(dialog.querySelector('[data-commerce-labels]').textContent);
    const route=window.Shopify?.routes?.root||'/';
    const currencySymbol04 = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: commerce.currency || window.Shopify?.currency?.active || 'EUR', currencyDisplay: 'narrowSymbol' }).formatToParts(0).find(part => part.type === 'currency')?.value || '€';
    const money=(price)=>String(Math.round(Number(price||0)/100))+' '+currencySymbol04;
    const closeSheet=()=>{loadId++;sheet.hidden=true;buy.setAttribute('aria-expanded','false');setPause(pausedBeforeSheet);if(dialog.open)buy.focus({preventScroll:true});};
    const openSheet=async()=>{
      const handle=photos[index]?.dataset.product;if(root.dataset.swipeShop==='false'||!handle||busy||!sheet.hidden)return;
      pausedBeforeSheet=paused;setPause(true);sheet.hidden=false;buy.setAttribute('aria-expanded','true');sheet.focus();
      const token=++loadId;selectedProduct=null;variant.replaceChildren();add.disabled=true;add.textContent=commerce.add;message.textContent=commerce.loading;dialog.querySelector('[data-product-title]').textContent='';dialog.querySelector('[data-product-price]').textContent='';
      const link=dialog.querySelector('[data-product-link]');link.href=route+'products/'+encodeURIComponent(handle);
      if(root.dataset.previewTheme)link.href+='?preview_theme_id='+root.dataset.previewTheme;
      try{
        const response=await fetch(route+'products/'+encodeURIComponent(handle)+'.js',{cache:'no-store'});if(!response.ok)throw Error(commerce.error);const product=await response.json();if(token!==loadId||sheet.hidden||!dialog.open)return;selectedProduct=product;
        dialog.querySelector('[data-product-title]').textContent=product.title;
        dialog.querySelector('[data-product-price]').textContent=money(product.price);
        const placeholder=new Option(commerce.choose,'');placeholder.disabled=true;placeholder.selected=true;variant.add(placeholder);
        product.variants.forEach(v=>{const option=new Option(v.title==='Default Title'?product.title:v.title,String(v.id));option.disabled=!v.available;variant.add(option);});
        if(!product.available){message.textContent=commerce.sold_out;variant.disabled=true;}
        else if(product.requires_selling_plan){message.textContent=commerce.error;variant.disabled=true;}
        else{message.textContent='';variant.disabled=false;if(product.variants.length===1){variant.value=String(product.variants[0].id);add.disabled=!product.variants[0].available;dialog.querySelector('[data-product-price]').textContent=money(product.variants[0].price);}variant.focus();}
      }catch(error){if(token===loadId)message.textContent=commerce.error;}
    };
    buy.addEventListener('click',openSheet);
    dialog.querySelector('[data-sheet-close]').addEventListener('click',closeSheet);
    variant.addEventListener('change',()=>{const v=selectedProduct?.variants.find(v=>String(v.id)===variant.value);add.disabled=busy||!v?.available;message.textContent='';if(v)dialog.querySelector('[data-product-price]').textContent=money(v.price);});
    dialog.querySelector('[data-cart-form]').addEventListener('submit',async e=>{
      e.preventDefault();const chosen=selectedProduct?.variants.find(v=>String(v.id)===variant.value);if(busy||!chosen?.available)return;
      busy=true;add.disabled=true;variant.disabled=true;add.textContent=commerce.adding;message.textContent='';
      let added=false,confirmedCart=null;
      try{
        const sectionIds=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
        const contextUrl=new URL(location.href);if(root.dataset.previewTheme)contextUrl.searchParams.set('preview_theme_id',root.dataset.previewTheme);
        const response=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:chosen.id,quantity:1}],sections:sectionIds,sections_url:contextUrl.pathname+contextUrl.search})});const result=await response.json();
        if(!response.ok||result.status)throw Error(result.description||result.message||commerce.error);
        added=true;message.textContent=commerce.added;
        try{
          const cartResponse=await fetch(route+'cart.js',{cache:'no-store'});if(!cartResponse.ok)throw Error();const cart=await cartResponse.json();confirmedCart=cart;
          const {CartLinesUpdateEvent}=await import('@shopify/events');
          sheet.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'dialog',lines:[{merchandiseId:String(chosen.id),quantity:1}],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:result.sections,itemCount:cart.item_count,items:cart.items,source:'archive-stories-04'}})}));
        }catch(error){if(confirmedCart)document.querySelectorAll('cart-icon').forEach(el=>el.renderCartBubble?.(confirmedCart.item_count));}
      }catch(error){message.textContent=error.message||commerce.error;}
      finally{busy=false;variant.disabled=false;add.textContent=commerce.add;add.disabled=added;}
    });
    dialog.addEventListener('cancel',e=>{if(busy){e.preventDefault();return;}if(!sheet.hidden){e.preventDefault();closeSheet();}});
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    progress.replaceChildren(...photos.map(()=>{const bar=document.createElement('span');bar.append(document.createElement('i'));return bar;}));
    const show=(n)=>{
      if(busy)return;if(n>=photos.length){dialog.close();return;}
      loadId++;sheet.hidden=true;buy.setAttribute('aria-expanded','false');index=Math.max(0,n);elapsed=0;last=0;
      buy.hidden=root.dataset.swipeShop==='false'||!photos[index].dataset.product;buy.textContent=photos[index].dataset.available==='false'?commerce.sold_out:'↑ '+commerce.swipe;
      const img=photos[index].querySelector('img');
      full.src=img.currentSrc||img.src;full.srcset=img.srcset;full.sizes='(max-width: 749px) 100vw, 56.25vh';full.alt=img.alt;
      counter.textContent=String(index+1).padStart(2,'0')+' / '+String(photos.length).padStart(2,'0');
      [...progress.children].forEach((bar,i)=>bar.firstChild.style.width=i<index?'100%':'0%');
    };
    const setPause=(value)=>{paused=value;pause.textContent=paused?'▷':'Ⅱ';pause.setAttribute('aria-label',paused?labels.dataset.playLabel:labels.dataset.pauseLabel);last=0;};
    const tick=(now)=>{
      if(!dialog.open)return;
      if(autoplay&&!paused&&sheet.hidden&&!document.hidden&&full.complete&&full.naturalWidth){if(last)elapsed+=Math.min(now-last,100);progress.children[index].firstChild.style.width=Math.min(elapsed/duration,1)*100+'%';if(elapsed>=duration)show(index+1);}
      last=now;if(dialog.open)frame=requestAnimationFrame(tick);
    };
    const openPhoto=(photo,i)=>{if(dialog.open){show(i);return;}opener=photo;previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';show(i);setPause(reduced||!autoplay);dialog.showModal();frame=requestAnimationFrame(tick);};
    photos.forEach((photo,i)=>photo.addEventListener('click',()=>openPhoto(photo,i)));
    root.addEventListener('shopify:block:select',e=>{const photo=photos.find(p=>p.dataset.blockId===e.detail?.blockId);if(photo){openPhoto(photo,photos.indexOf(photo));setPause(true);}});
    root.cleanupArchive=()=>{cancelAnimationFrame(frame);if(dialog.open)dialog.close();};
    dialog.querySelector('[data-close]').addEventListener('click',()=>{if(!busy)dialog.close();});
    dialog.querySelector('[data-prev]').addEventListener('click',()=>{if(!suppressClick)show(index-1);});
    dialog.querySelector('[data-next]').addEventListener('click',()=>{if(!suppressClick)show(index+1);});
    pause.addEventListener('click',()=>setPause(!paused));
    dialog.addEventListener('close',()=>{cancelAnimationFrame(frame);loadId++;sheet.hidden=true;document.documentElement.style.overflow=previousOverflow;opener?.focus({preventScroll:true});});
    dialog.addEventListener('keydown',e=>{if(!sheet.hidden)return;if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}if(e.code==='Space'){e.preventDefault();setPause(!paused);}});
    dialog.addEventListener('pointerdown',e=>{if(e.target.closest('.a04-story-info,.a04-sheet')||busy)return;pointer={x:e.clientX,y:e.clientY};});
    dialog.addEventListener('pointerup',e=>{if(!pointer)return;const dx=e.clientX-pointer.x,dy=e.clientY-pointer.y;pointer=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){e.preventDefault();suppressClick=true;setTimeout(()=>suppressClick=false,200);show(index+(dx<0?1:-1));}else if(dy<-70&&Math.abs(dy)>Math.abs(dx)){suppressClick=true;setTimeout(()=>suppressClick=false,200);openSheet();}else if(dy>100&&Math.abs(dy)>Math.abs(dx)&&!busy)dialog.close();});
    dialog.addEventListener('pointercancel',()=>pointer=null);
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  };
  document.querySelectorAll('[data-archive-stories]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-archive-stories]').forEach(init));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-archive-stories]').forEach(root=>root.cleanupArchive?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immersive-coverflow"] && !Shopify.designMode) return;
  try {
    
  function initImmersiveCoverflow(root) {
    if (root.dataset.immersiveInitialized === 'true') return;
    root.dataset.immersiveInitialized = 'true';

    const rail = root.querySelector('[id^="immersive-rail-"]');
    const prevBtn = root.querySelector('[id^="immersive-prev-"]');
    const nextBtn = root.querySelector('[id^="immersive-next-"]');
    if (!rail) return;

    const cards = [...rail.querySelectorAll('.immersive-card')]; // real cards only, in author order
    if (cards.length === 0) return;

    const loopable = cards.length > 1;
    let beforeClones = [];
    let afterClones = [];

    function makeClone(card) {
      const clone = card.cloneNode(true);
      clone.dataset.isClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      [...clone.attributes].forEach((attr) => {
        if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
      });
      return clone;
    }

    if (loopable) {
      // Duplicate the full card set on both sides so scrolling past either end
      // of the real set lands on look-alike clones instead of empty space —
      // the illusion of an infinite loop. checkLoopReposition() below silently
      // snaps back into the real set once a clone becomes the active card.
      beforeClones = cards.map(makeClone);
      afterClones = cards.map(makeClone);
      beforeClones.forEach((clone) => rail.insertBefore(clone, rail.firstChild));
      afterClones.forEach((clone) => rail.appendChild(clone));
    }

    const allCards = [...rail.querySelectorAll('.immersive-card')];

    let activeIndex = -1;
    let activeEl = null;
    let raf = null;

    function updateActive() {
      const railRect = rail.getBoundingClientRect();
      const centerX = railRect.left + railRect.width / 2;
      let bestEl = allCards[0];
      let bestDist = Infinity;

      allCards.forEach((card) => {
        const r = card.getBoundingClientRect();
        const dist = Math.abs((r.left + r.right) / 2 - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          bestEl = card;
        }
      });

      if (bestEl !== activeEl) {
        activeEl = bestEl;
        allCards.forEach((card) => {
          const isActive = card === activeEl;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        const realIndex = Number(activeEl.dataset.cardIndex);
        if (realIndex !== activeIndex) {
          activeIndex = realIndex;
          rail.dispatchEvent(new CustomEvent('immersive:card-activated', {
            detail: { index: activeIndex, cardEl: activeEl },
          }));
        }
      }
    }

    function loopSpan() {
      // Distance between a real card and its same-index clone in the next set —
      // equal to the width of one full card set (cards + gaps) since the rail
      // is one continuous flex row with a uniform gap throughout.
      if (!loopable) return 0;
      return cards[0].getBoundingClientRect().left - beforeClones[0].getBoundingClientRect().left;
    }

    let settleTimer = null;
    function checkLoopReposition() {
      if (!loopable || !activeEl) return;
      const span = loopSpan();
      if (!span) return;
      if (beforeClones.includes(activeEl)) {
        rail.scrollLeft += span;
        updateActive();
      } else if (afterClones.includes(activeEl)) {
        rail.scrollLeft -= span;
        updateActive();
      }
    }

    rail.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActive);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(checkLoopReposition, 120);
    });

    // Cards start veiled (blurred/dimmed); reveal on the visitor's first scroll
    // interaction, whether it came from the wheel handler below, a touch swipe
    // (native overflow-x scrolling), or the prev/next arrows.
    rail.addEventListener('scroll', () => rail.classList.remove('is-veiled'), { once: true });

    window.addEventListener('resize', updateActive);

    // Let a vertical mouse wheel drive the horizontal rail (trackpad horizontal
    // swipes already scroll the rail natively via overflow-x, so only take over
    // when the wheel's dominant axis is vertical).
    rail.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      e.preventDefault();
      rail.scrollLeft += e.deltaY;
    }, { passive: false });

    function cardStep() {
      return cards[0].getBoundingClientRect().width + 48; // card width + gap
    }

    if (nextBtn) nextBtn.addEventListener('click', () => rail.scrollBy({ left: cardStep(), behavior: 'smooth' }));
    if (prevBtn) prevBtn.addEventListener('click', () => rail.scrollBy({ left: -cardStep(), behavior: 'smooth' }));

    allCards.forEach((card) => {
      card.addEventListener('click', (e) => {
        const isHashLink = card.getAttribute('href') === '#';
        if (!card.classList.contains('is-active')) {
          e.preventDefault();
          // rail.scrollLeft (not card.scrollIntoView, which also scrolls the
          // page/ancestors vertically into view — see the page-load fix above
          // for why that's unsafe here).
          const target = card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2;
          rail.scrollTo({ left: target, behavior: 'smooth' });
        } else if (isHashLink) {
          e.preventDefault();
        }
      });
    });

    cards.forEach((card) => {
      card.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          rail.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
          rail.addEventListener('immersive:card-activated', (activatedEvent) => {
            const focusedCard = cards[activatedEvent.detail.index];
            if (focusedCard) focusedCard.focus();
          }, { once: true });
        }
      });
    });

    // Start centered on the first real card (not the first clone) so the loop
    // is invisible on load. Set the rail's own scrollLeft directly rather than
    // cards[0].scrollIntoView() — scrollIntoView also scrolls ancestor/page
    // scroll containers into view, which yanked the whole page down to this
    // section on load (this section sits further down the homepage, so on
    // first paint it isn't in the viewport yet and scrollIntoView "fixed"
    // that by scrolling the page — confirmed as a mobile bug in production).
    rail.scrollLeft = cards[0].offsetLeft - (rail.clientWidth - cards[0].offsetWidth) / 2;
    requestAnimationFrame(updateActive);

    const bgStack = root.querySelector('[id^="immersive-bgstack-"]');
    // The templates root renders as a sibling of the section element (outside it, in the
    // markup below), not a descendant, so it can't be found via root.querySelector.
    // Look it up at the document level, scoped by the section id shared with the rail's id.
    const sectionIdSuffix = rail.id.replace('immersive-rail-', '');
    const bgTemplatesRoot = document.getElementById('immersive-bg-templates-' + sectionIdSuffix);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (bgStack && bgTemplatesRoot) {
      const templates = new Map(
        [...bgTemplatesRoot.querySelectorAll('template')].map((t) => [Number(t.dataset.bgIndex), t])
      );
      const mounted = new Map(); // index -> mounted element

      function mount(index) {
        if (mounted.has(index) || !templates.has(index)) return;
        const node = templates.get(index).content.cloneNode(true);
        const wrapper = document.createElement('div');
        wrapper.className = 'immersive-bg';
        wrapper.dataset.bgIndex = String(index);
        wrapper.appendChild(node);
        if (reduceMotion) {
          wrapper.querySelectorAll('video').forEach((v) => v.removeAttribute('autoplay'));
        }
        bgStack.appendChild(wrapper);
        mounted.set(index, wrapper);
      }

      function unmount(index) {
        const wrapper = mounted.get(index);
        if (!wrapper) return;
        wrapper.querySelectorAll('video').forEach((v) => v.pause());
        wrapper.remove();
        mounted.delete(index);
      }

      function setActiveBg(index) {
        const n = cards.length;
        const neighbors = loopable
          ? [index - 1, index, index + 1].map((i) => (i + n) % n)
          : [index - 1, index, index + 1].filter((i) => i >= 0 && i < n);
        neighbors.forEach(mount);
        [...mounted.keys()].forEach((i) => {
          if (!neighbors.includes(i)) unmount(i);
        });
        mounted.forEach((wrapper, i) => wrapper.classList.toggle('is-active', i === index));
      }

      setActiveBg(0);
      rail.addEventListener('immersive:card-activated', (e) => setActiveBg(e.detail.index));
    }
  }

  document.querySelectorAll('.immersive-coverflow').forEach(initImmersiveCoverflow);
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.immersive-coverflow');
    if (root) initImmersiveCoverflow(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
